import { withStyles } from '@material-ui/core/styles';
import styles from './CardRounded.styles';
import CardRounded from './CardRounded';

export default withStyles(styles)(CardRounded);
